require('./teamInfoManagerController');

"use strict";

angular.module('app.admin.teamInfoManager', [
    'angular-click-outside',
    'app.admin.teamInfoManager.teamInfoManagerController'
])
.config([
    '$stateProvider',
    function ($stateProvider) {
        $stateProvider.state('app.admin.teamInfoManager', {
            url: '/team_info_manager',
            controller: 'app.admin.teamInfoManager.teamInfoManagerController',
            templateUrl: 'components/admin/teamInfoManager/teamInfoManagerView.html',
            title: 'Team Info Manager'
        });
    }
]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/teamInfoManager/teamInfoManager.js